import {
  Activity,
  Download,
  History,
  Lock,
  Settings,
  Upload,
} from "lucide-react";

export interface PaletteToolbarProps {
  paletteHistoryCount: number;
  isGeneratingTokens: boolean;
  onShowPermissions: () => void;
  onShowActivity: () => void;
  onShowHistory: () => void;
  onShowImport: () => void;
  onShowExport: () => void;
  onGenerateTokens: () => void;
}

export function PaletteToolbar({
  paletteHistoryCount,
  isGeneratingTokens,
  onShowPermissions,
  onShowActivity,
  onShowHistory,
  onShowImport,
  onShowExport,
  onGenerateTokens,
}: PaletteToolbarProps) {
  return (
    <div className="pal-toolbar">
      <button
        type="button"
        onClick={onShowPermissions}
        className="pal-toolbar-btn bg-indigo-600 hover:bg-indigo-700 text-white"
        title="Manage permissions and sharing"
        aria-label="Manage permissions"
      >
        <Lock className="w-4 h-4" />
        <span className="hidden sm:inline">Permissions</span>
      </button>
      <button
        type="button"
        onClick={onShowActivity}
        className="pal-toolbar-btn bg-purple-600 hover:bg-purple-700 text-white"
        title="View activity log"
        aria-label="View activity log"
      >
        <Activity className="w-4 h-4" />
        <span className="hidden sm:inline">Activity</span>
      </button>
      <button
        type="button"
        onClick={onShowHistory}
        className="pal-toolbar-btn bg-gray-600 hover:bg-gray-700 text-white"
        title="View version history"
        aria-label="View version history"
      >
        <History className="w-4 h-4" />
        <span className="hidden sm:inline">History ({paletteHistoryCount})</span>
      </button>
      <button
        type="button"
        onClick={onShowImport}
        className="pal-toolbar-btn bg-green-600 hover:bg-green-700 text-white"
        title="Import palette from file"
        aria-label="Import palette from file"
      >
        <Upload className="w-4 h-4" />
        <span className="hidden sm:inline">Import</span>
      </button>
      <button
        type="button"
        onClick={onShowExport}
        className="pal-toolbar-btn bg-blue-600 hover:bg-blue-700 text-white"
        aria-label="Export palette"
        title="Export palette"
      >
        <Download className="w-4 h-4" />
        <span className="hidden sm:inline">Export</span>
      </button>
      <button
        type="button"
        onClick={onGenerateTokens}
        disabled={isGeneratingTokens}
        className="pal-toolbar-btn bg-purple-600 hover:bg-purple-700 disabled:bg-purple-400 text-white"
        title="Generate design tokens from this palette"
        aria-label="Generate design tokens"
      >
        {isGeneratingTokens ? (
          <span className="w-4 h-4 inline-block animate-spin">⟳</span>
        ) : (
          <Settings className="w-4 h-4" />
        )}
        <span className="hidden sm:inline">Tokens</span>
      </button>
    </div>
  );
}
